var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"thumb",staticClass:"gallery-thumb user-select-none",class:{
    active: _vm.active,
    'video-shown': _vm.videoShown,
    loading: !_vm.thumbLoaded,
    'in-slider': _vm.inSlider,
    'in-zoomer': _vm.inZoomer
  },attrs:{"draggable":"false","ondragstart":"return false"},on:{"click":_vm.thumbClicked}},[_c('img',{ref:"image",staticClass:"thumb-img",attrs:{"data-index":_vm.index,"draggable":"false","src":_vm.imageSource,"alt":_vm.title + '-thumb-' + _vm.index,"ondragstart":"return false"}}),_vm._v(" "),(_vm.image.type === 'img360')?_c('div',{staticClass:"watermark360"},[_c('CBadge360',{staticClass:"mt-0",attrs:{"small":""}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }